import { C } from '../../theme.js';
import { Eyebrow, FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { MultiCols } from '../shared/MultiCols.jsx';

// ── Left trim inspector ─────────────────────────────────────────────────
export function LeftTrimInspector({ step, onChange }) {
  const c = step.config || {};
  const sel = c.columns || [];
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <Eyebrow>Left trim columns</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Strips leading characters from the chosen string columns.
        With no columns selected, every string column is left-trimmed.
      </div>
      <MultiCols selected={sel} onChange={(v) => u({ columns: v })} />
      <FieldLabel hint="Blank = all leading whitespace">Character count</FieldLabel>
      <TextInput mono value={c.count != null ? String(c.count) : ''} onChange={(v) => u({ count: v.trim() === '' ? null : (parseInt(v) || 0) })} placeholder="All whitespace" />
    </div>
  );
}
